export default __webpack_public_path__ + "static/media/photo.fa92252f.png";